export default {
  init() {
    // JavaScript to be fired on all pages

    $('#yith-searchsubmit').click(function () {
      $('#yith-s').focus();
    });

    $('label[for="mailchimp_woocommerce_newsletter"]:lang(en-US)').html('I\'d like to receive the delCane newsletter. I agree to the processing of data in accordance with the <a href="/privacy-policy" target="_blank">Privacy policy</a>.');

    $( 'ul.products > li.product' )
      .mouseenter(function() {
        $( this ).addClass('hover');
      })
      .mouseleave(function() {
        $( this ).removeClass('hover');
      });

    // DISPLAY SIZE INFO on SINGLE PRODUCT PAGE

    var activeSize = $('#pa_rozmiar').val();

    $('#pa_rozmiar').change(function() {
      activeSize = $('#pa_rozmiar').val();
      showSizeInfo();
    });

    function showSizeInfo() {

      if (activeSize ===  's' || activeSize ===  's-en') {
        $('.size-info').hide();
        $('.size-s').show();
      } else if (activeSize ===  'm' || activeSize ===  'm-en') {
        $('.size-info').hide();
        $('.size-m').show();
      } else if (activeSize ===  'l' || activeSize ===  'l-en') {
        $('.size-info').hide();
        $('.size-l').show();
      }

    }

    showSizeInfo();

    $('[data-toggle="tooltip"]').tooltip();

    // MAIN MENU
    if(( $(window).width() >= 991 )) {
      /** Dropdown on hover */
      $('.nav-link.dropdown-toggle').hover( function () {
        // Open up the dropdown
        $(this).removeAttr('data-toggle'); // remove the data-toggle attribute so we can click and follow link
        $(this).parent().addClass('show'); // add the class show to the li parent
        $(this).next().addClass('show'); // add the class show to the dropdown div sibling
      }, function () {
        // on mouseout check to see if hovering over the dropdown or the link still
        var isDropdownHovered = $(this).next().filter(':hover').length; // check the dropdown for hover - returns true of false
        var isThisHovered = $(this).filter(':hover').length;  // check the top level item for hover
        if(isDropdownHovered || isThisHovered) {
          // still hovering over the link or the dropdown
        } else {
          // no longer hovering over either - lets remove the 'show' classes
          $(this).attr('data-toggle', 'dropdown'); // put back the data-toggle attr
          $(this).parent().removeClass('show');
          $(this).next().removeClass('show');
        }
      });
      // Check the dropdown on hover
      $('.dropdown-menu').hover( function () {
      }, function() {
        var isDropdownHovered = $(this).prev().filter(':hover').length; // check the dropdown for hover - returns true of false
        var isThisHovered= $(this).filter(':hover').length;  // check the top level item for hover
        if(isDropdownHovered || isThisHovered) {
          // do nothing - hovering over the dropdown of the top level link
        } else {
          // get rid of the classes showing it
          $(this).parent().removeClass('show');
          $(this).removeClass('show');
        }
      });
    }

    // MOBILE NAVBAR OPEN STATE
    $('#navbarContent').on('show.bs.collapse', function () {
      $('#navigation').addClass('active');
      // $('#main').hide();
      // $('#brand-footer').hide();
      // $('#main-footer').hide();
    });

    // MOBILE NAVBAR CLOSED STATE
    $('#navbarContent').on('hide.bs.collapse', function () {
      $('#navigation').removeClass('active');
      // $('#main').show();
      // $('#brand-footer').show();
      // $('#main-footer').show();
    });

    // RESOLUTION CHANGE RESET ->>> MOBILE
    function resetToMobileDefault() {

    }

    // RESOLUTION CHANGE RESET ->>> DESKTOP
    function resetToDesktopDefault() {
      $('#navigation').removeClass('active');
      $('#main').show();
      $('#main-footer').show();
    }

    // //RESET ON RESIZE
    // WINDOWS RESIZE -> WIDTH CHANGE ONLY
    var width = $(window).width();
    $(window).on('resize', function() {
      if ($(this).width() != width) {
        width = $(this).width();
        //RESET ON RESIZE
        if (screen.width >= 992) {
          resetToDesktopDefault();
        } else {
          resetToMobileDefault();
        }
      }
    });

    $('.top').click(function () {
      $('html, body').animate({
        scrollTop: $('body').offset().top,
      }, 800, 'swing');
    });

    $(window).scroll(function() {
      let scroll = $(window).scrollTop();

      if (scroll >= 800) {
        $('#to-top').fadeIn();
      } else {
        $('#to-top').fadeOut();
      }
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js